import { render, staticRenderFns } from "./DasboardTask.vue?vue&type=template&id=46ad63e2&scoped=true&"
import script from "./DasboardTask.vue?vue&type=script&lang=js&"
export * from "./DasboardTask.vue?vue&type=script&lang=js&"
import style0 from "./DasboardTask.vue?vue&type=style&index=0&id=46ad63e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad63e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VIcon,VSnackbar})
